<template>
    <path
        d="M9.73477 4.48828C6.08477 4.48828 3.13477 7.44662 3.13477 11.0883C3.13477 14.7383 6.0931 17.6883 9.73477 17.6883C13.3848 17.6883 16.3348 14.7299 16.3348 11.0883H9.73477V4.48828Z"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path d="M11.6934 2.48047C15.3434 2.48047 18.2934 5.4388 18.2934 9.08047H11.6934V2.48047Z" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
</template>
